/* global dataLayer, homeLanguage */
'use strict';

var Cookies = global.Cookies = require('js-cookie/src/js.cookie'); // for manipulating / retrieving cookies

/**
 * Country Selector
 * This module can be used to facilitate the country selection dialog
 * if the site being browsed is for a different country than the users
 * GeoIP location
 */

const cookieName = 'countrySelectionCookie';

/**
 * Get Home Country Code
 *
 * @returns {string} Home Country Code
 */
function getVisitingCountry() {
    return $('.country-language-selection-overlay').attr('data-country-selector-visiting');
}

/**
 * Hide Overlay
 */
function hideOverlay() {
    $('.country-selection-background').hide();
    $('.country-language-selection-overlay').css({
        display: 'none'
    });
    $('.modal.country-selection-modal').modal('hide').remove();
}

/**
 * Close the Overlay and Cookie the user for the home country
 *
 * @param {event} event DOM Event
 */
function closeOverlay(event) {
    event.preventDefault();

    /**
     * Get the country code for the home country
     */
    var visitingCountryCountryCode = getVisitingCountry();

    Cookies.set(cookieName, visitingCountryCountryCode, { expires: 30 });

    hideOverlay();
}

/**
 * Go to Country
 * Cookie the user and follow the link
 * @param {string} selectedElement Optional parameter, eg. URL string
 */
function goToCountry($countryLink) {
    Cookies.set(cookieName, $countryLink.data('country-code'), { expires: 30 });
    if ($countryLink.attr('href')) {
        window.location = $countryLink.attr('href');
    }
}

/**
 * Go to Home Country
 * Cookie the user and follow the link
 */
function goToVisitingCountry() {
    Cookies.set(cookieName, getVisitingCountry(), { expires: 30 });
}

/**
 * Show Overlay
 */
function showOverlay() {
    var $countryOverlay = $('.country-language-selection-overlay');
    if ($countryOverlay.length) {
        // If overlay content already exists in DOM, use it directly
        $.modal({
            title: '',
            content: $countryOverlay[0].outerHTML,
            customClasses: 'country-selection-modal',
            modalSizeClass: 'modal-lg',
            backdrop: false
        }).one('shown.bs.modal', function () {
            $('body').removeClass('modal-open').css('padding-right', '');

            // Bind country link events after modal is shown
            $('.modal.country-selection-modal .js-action__gotocountry').each(function () {
                var $thisLink = $(this);
                var visitingCountryLang = $thisLink.attr('data-visiting-language');
                var thisLinkCountryCode = $thisLink.attr('data-country-code');

                if ($thisLink[0].hostname === window.location.hostname && visitingCountryLang === homeLanguage && thisLinkCountryCode === getVisitingCountry()) {
                    $thisLink.on('click', closeOverlay);
                } else {
                    $thisLink.on('click', function (event) {
                        event.preventDefault();
                        if ($thisLink[0].hostname === window.location.hostname && visitingCountryLang !== homeLanguage) {
                            $thisLink.attr('href', $thisLink.attr('href') + window.location.search);
                        }
                        goToCountry($thisLink);
                    });
                }
            });
            var viewAllLink = $('.country-language-selection-overlay').find('.js-action__viewall'); // Bind using direct selector instead of $countryOverlay
            viewAllLink.on('click', goToVisitingCountry);

            // Bind close events
            $('.modal.country-selection-modal').on('hidden.bs.modal', closeOverlay);
            $('.modal.country-selection-modal, .country-selection-background').on('click', closeOverlay);
            $('.modal.country-selection-modal .country-language-selection-overlay').on('click', function (e) {
                e.stopPropagation();
            });
        });
    }

    // Show the country overlay content
    $('.modal.country-selection-modal .country-language-selection-overlay').css({
        display: 'block'
    });

    /**
     * Show the Background
     */
    $('.country-selection-background').show();
}

/**
 * Has Popup Modal URL
 * grabs a tag by class, then on click adds href of the country's url
 * and dynamically renders title, content and buttons
 */
function getPopUpModalURL() {
    $('.js-action__showpopupmodaltoexternalsite').on('click', function (e) {
        e.preventDefault();
        var externalUrl = $(this).data('url');
        $.modal({
            title: window.resources.leavingSiteModal.title,
            content: `<p>${window.resources.leavingSiteModal.body}</p><p>${window.resources.leavingSiteModal.proceed}</p>`,
            modalSizeClass: 'modal-md',
            buttons: [
                `<a href="${externalUrl}" class="btn btn-primary btn-country__link" role="button" target="_blank">${window.resources.leavingSiteModal.buttonOK}</a>`,
                `<button type="button" class="btn btn-primary d-block" data-dismiss="modal">${window.resources.leavingSiteModal.buttonCancel}</button>`
            ]
        });
    });
}


module.exports = function () {
    getPopUpModalURL();
    var countrySelectorOverlay = $('.country-language-selection-overlay');

    /**
     * Checks
     * =========================
     */

    /**
     * If the overlay doesn't exist, return because there is nothing for us to do
     */
    if (countrySelectorOverlay.length <= 0) {
        return;
    }

    /**
     * Check for Country Selection Cookie
     * If cookie exists and matches the visiting country, return
     */
    if (Cookies.get(cookieName) !== undefined) {
        var cookieCountryCode = Cookies.get(cookieName);

        if (cookieCountryCode === getVisitingCountry()) {
            return;
        }
    }

    /**
     * Show Overlay
     * =========================
     */
    showOverlay();
};
